var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5352 8.81828L5.10889 8.81828",
    stroke: "#9097A3",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29712 11.6064L5.27331 11.6064C3.7085 11.6064 2.43998 10.3379 2.43998 8.77311V8.77311C2.43998 7.20831 3.7085 5.93978 5.27331 5.93978L7.29712 5.93978",
    stroke: "#9097A3",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91602 11.6064L10.9398 11.6064C12.5046 11.6064 13.7732 10.3379 13.7732 8.77311V8.77311C13.7732 7.20831 12.5046 5.93978 10.9398 5.93978L8.91602 5.93978",
    stroke: "#9097A3",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedItemIcon);
export default __webpack_public_path__ + "static/media/linked-item-icon.93bf9de344bbe9783c69495388378609.svg";
export { ForwardRef as ReactComponent };